/* eslint-disable react-hooks/exhaustive-deps */

import "./styles.css";

import React from "react";

// import Alert from './components/Alert';
import Footer from "./components/Footer";
import Header from "./components/Header";
import IframeGame from "./components/IframeGame";
import Login from "./components/Login";
import MetaLinks from "./components/MetaLinks";
import Servers from "./components/Servers";
import Spinner from "./components/Spinner";
import useEventListener from "./utils/use-event-listener";
import Alert from "./components/Alert";

type ServerInfo = {
  title: string;
  label: string;
  href: string;
};
// const ERROR_CODE_AUTH = -14006;
declare global {
  interface Window {
    ZGS: any;
    ZagooSupport: any;
  }
}

function App() {
  const [sdkInstant, setSdkInstant] = React.useState(false);

  const [userInfo, setUserInfo] = React.useState(null);
  const [iframeSrc, setIframeSrc] = React.useState("");
  const [servers, setServers] = React.useState<ServerInfo[]>([]);
  const [serverMessage, setServerMessage] = React.useState("");
  const [clientConfig, setClientConfig] = React.useState<{
    [key: string]: any;
  }>({});

  React.useEffect(() => {
    // config left button
    window.ZJSBridge.H5.configLeftButton({
      buttonType: 1,
      dataConfig: {
        confirmToExit: 2,
        dialogMessage: "",
      },
    });
  }, []);

  React.useEffect(() => {
    window.ZJSBridge.onCloseWebview(() => {
      window.ZJSBridge.H5.closeWebview();
    });
  }, [clientConfig]);

  function calculateScale() {
    const { innerWidth, innerHeight } = window;

    console.log(
      "calculateScale :: innerWidth: ",
      innerWidth,
      ", innerHeight: ",
      innerHeight
    );

    const DESIGN_WIDTH = 768;
    const DESIGN_HEIGHT = 1368;

    const scaleH = innerHeight / DESIGN_HEIGHT;
    const scaleW = innerWidth / DESIGN_WIDTH;
    // let scale = Math.min(scaleW, scaleH);
    let scale = Math.min(scaleH, 1);

    const r = document.querySelector(":root") as HTMLElement;
    // console.log(r);
    r.style.setProperty("--scale", `${scale}`);
    r.style.setProperty(
      "--content-scale",
      `${Math.min(1, Math.min(scaleW, scaleH))}`
    );
  }

  useEventListener("resize", () => {
    calculateScale();
  });

  React.useEffect(() => {
    calculateScale();
  }, []);

  const handlePickServer = (link: string) => {
    setIframeSrc(link);
  };

  const handleLogoutZalo = () => {
    if (sdkInstant && window.ZGS) {
      window.ZGS.logoutZalo()
        .then(() => {
          setUserInfo(null);
        })
        .catch((err: Error) => {
          console.error(err);
        });
    }
  };

  return !iframeSrc ? (
    <div className="vggd-main">
      <Header />
      <div className="vggd-container">
        <Alert severity="error" />
      </div>

      <Footer />
      {/* </div> */}

      {/* {loginError !== null && (
        <Alert
          severity='error'
          message='Đăng nhập không thành công. Vui lòng thử lại sau!'
        />
      )} */}
    </div>
  ) : (
    <>
      <IframeGame src={iframeSrc} />
      {/* <div className='vggd-button-social' id='vggd-id-button-social' /> */}
      {/* <button onClick={handleTestPayment}>Test Payment </button> */}
    </>
  );
}

export default App;
